import React from "react";
import { Link } from "react-router-dom";
import { Play, Building2, Image as ImageIcon, Users, Home, LogOut, X, UserCircle } from "lucide-react";
import { FREE_VIDEOS_TAB, STUDIO_SCENES_TAB, GALLERY_TAB, CAST_TAB, ESCORT_TAB } from "@/lib/freeArea";

export default function FreeAreaSidebar({ 
  activeTab, 
  sidebarOpen, 
  setSidebarOpen, 
  changeTab, 
  handleLogout 
}) {
  const navItems = [
    { id: FREE_VIDEOS_TAB, label: "Videos", icon: Play, testid: "sidebar-videos" },
    { id: STUDIO_SCENES_TAB, label: "Studio Scenes", icon: Building2, testid: "sidebar-studio" },
    { id: GALLERY_TAB, label: "Gallery", icon: ImageIcon, testid: "sidebar-gallery" },
    { id: CAST_TAB, label: "Cast & Crew", icon: Users, testid: "sidebar-cast" },
    { id: ESCORT_TAB, label: "Companion", icon: UserCircle, testid: "sidebar-escort" },
  ];

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#0F1118] border-r border-white/10 transform transition-transform duration-300 lg:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Sidebar Header */}
          <div className="p-6 border-b border-white/10">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="relative">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E11D48] to-[#FF10F0] flex items-center justify-center font-bold text-sm border-2 border-[#D4AF37]/50 shadow-[0_0_20px_rgba(225,29,72,0.3)]">
                  GP
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-[#E11D48] rounded-full animate-pulse border-2 border-[#0F1118]" />
              </div>
              <div>
                <div
                  className="text-lg font-extrabold tracking-tight"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  GioPilos
                </div>
                <div className="text-[9px] font-mono uppercase tracking-[0.2em] text-[#D4AF37]">
                  Free Tier
                </div>
              </div>
            </Link>
            <button
              type="button"
              aria-label="Close member navigation"
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden absolute top-4 right-4 flex h-11 w-11 items-center justify-center rounded-lg transition-colors hover:bg-white/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
            >
              <X size={20} />
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {navItems.map((item) => {
              const isActive = activeTab === item.id;
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    changeTab(item.id);
                    setSidebarOpen(false);
                  }}
                  data-testid={item.testid}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-sm transition-all duration-200 ${
                    isActive
                      ? "bg-gradient-to-r from-[#E11D48] to-[#FF10F0] text-white shadow-[0_0_15px_rgba(225,29,72,0.3)]"
                      : "text-zinc-400 hover:text-white hover:bg-white/5"
                  }`}
                >
                  <Icon size={18} />
                  {item.label}
                  {isActive && (
                    <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                  )}
                </button>
              );
            })}
          </nav>

          {/* Sidebar Footer */}
          <div className="p-4 border-t border-white/10 space-y-2">
            <Link
              to="/"
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-sm text-zinc-400 hover:text-white hover:bg-white/5 transition-colors"
              data-testid="sidebar-home"
            >
              <Home size={18} />
              Back to Home
            </Link>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-sm text-zinc-400 hover:text-white hover:bg-white/5 transition-colors"
              data-testid="sidebar-logout"
            >
              <LogOut size={18} />
              Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
}
